// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pmJ25","dots":"styles_dots__biqlr","dot":"styles_dot__5Cgvh","viewedDot":"styles_viewedDot__zQExD"};